$(document).ready(function () {

    // Resolve an invisible reCAPTCHA v3 token (action: "search"). The api.js script loads async,
    // so grecaptcha may not be ready yet on a fresh page load; poll briefly until it is.
    function executeRecaptcha() {
        return new Promise(function (resolve, reject) {
            if (typeof recaptchaSiteKey === "undefined" || !recaptchaSiteKey) {
                reject();
                return;
            }

            var attempts = 0;
            (function waitForGrecaptcha() {
                if (typeof grecaptcha !== "undefined" && grecaptcha.execute) {
                    grecaptcha.ready(function () {
                        grecaptcha.execute(recaptchaSiteKey, { action: "search" }).then(resolve, reject);
                    });
                } else if (attempts++ < 40) {
                    setTimeout(waitForGrecaptcha, 200);
                } else {
                    reject();
                }
            })();
        });
    }

    // Mint a token and POST it to the verify endpoint (token in a header, never the url). On success
    // the server sets the short-lived verification cookie; we then navigate to the clean url and the
    // server admits the search via that cookie. When captcha is disabled, navigate directly. If we
    // can't verify (api.js blocked / low score) and an onCannotVerify handler is supplied, it runs
    // instead of navigating, so callers can stop rather than loop.
    function verifyThenNavigate(url, onCannotVerify) {
        if (typeof recaptchaSiteKey === "undefined" || !recaptchaSiteKey) {
            window.location.replace(url);
            return;
        }

        executeRecaptcha()
            .then(function (token) {
                return new Promise(function (resolve, reject) {
                    $.ajax({
                        url: window.location.origin + "/search/Verify",
                        type: "POST",
                        headers: {
                            "X-Recaptcha-Token": token,
                            RequestVerificationToken: $('input:hidden[name="__RequestVerificationToken"]').val()
                        }
                    }).done(resolve).fail(reject);
                });
            })
            .then(function () {
                window.location.replace(url);
            })
            .catch(function () {
                if (typeof onCannotVerify === "function") {
                    onCannotVerify();
                } else {
                    window.location.replace(url);
                }
            });
    }

    // sessionStorage one-shot so a browser that can't persist the verification cookie (cookies
    // disabled) can't drive an endless reload loop. Cleared automatically once a search renders.
    var VERIFY_ATTEMPTED = "searchVerifyAttempted";

    // Handle anonymous verification for direct navigations (pasted / bookmarked / header / paging).
    // These reach the server gate without a verification cookie, so the page renders blocked. Rather
    // than show an error, verify once in the background and reload the SAME url (all filters preserved).
    // On success the cookie is set and the reload renders results; on failure we restore the error and
    // stop. Because we only reload after a successful verify, transient/low-score failures never loop.
    (function handleAnonymousVerification() {
        if (typeof verificationFailed === "undefined" || !verificationFailed) {
            sessionStorage.removeItem(VERIFY_ATTEMPTED);
            return;
        }

        if (sessionStorage.getItem(VERIFY_ATTEMPTED) === "1") {
            return;
        }

        sessionStorage.setItem(VERIFY_ATTEMPTED, "1");
        $(".no-item-message").hide();
        verifyThenNavigate(window.location.href.split("#")[0], function () {
            $(".no-item-message").show();
        });
    })();

    var tags = "";
    var category = "";
    var sortBy = "";
    var pivot = "";
    var freshSearch = false;

    var currentQuery = new URLSearchParams(window.location.search);
    var searchTerm = currentQuery.get("q");

    $(".categoryFilter").click(function () {
        pivot = "cf";
        doSearch();
    });

    $("#tags").change(function () {
        pivot = "tags";
        doSearch();
    });

    if (document.getElementById("contentTypeFilterMobile") && window.getComputedStyle(document.getElementById("contentTypeFilterMobile")).display != "none") {
        $("#contentTypes").change(function () {
            pivot = "cf";
            doSearch();
        });
    }

    $("#sort").change(function () {
        var query = new URLSearchParams(window.location.search);
        pivot = query.get("pivot");
        doSearch();
    });

    $("#searchForm").on("submit", function () {
        freshSearch = true;
        var query = new URLSearchParams(window.location.search);
        pivot = query.get("pivot");
        doSearch();
        return false;
    });

    $("#clearTopics").click(function () {
        pivot = "tags";
        $("#tags").val("All Topics");
        doSearch();
        return false;
    });

    $(".adClose").click(function (event) {
        let sponsoredAd = event.target.closest(".sponsoredAd");
        $(sponsoredAd).removeClass("d-flex").addClass("d-none");
    });

    $("#clearCategories").click(function () {
        pivot = "cf";
        $('.categoryFilter:input:checked').removeAttr('checked');
        $("#contentTypes").val("Select a Category");
        doSearch();
        return false;
    });

    function doSearch() {

        if (document.getElementById("contentTypeFilterMobile") && window.getComputedStyle(document.getElementById("contentTypeFilterMobile")).display != "none") {
            category = $("#contentTypes").val();
        } else {
            $('.categoryFilter:input:checked').each(function () {
                category += $(this).val() + "-and-";
            });
        }

        tags = $("#tags").val();
        sortBy = $("#sort").val() == undefined ? sortBy : $("#sort").val();
        category = category.replace(/(\s*,?\s*)*$/, "").replaceAll("#", "");

        var searchWord = $("#searchBox").val();

        //Search/Init?q=t
        var url = window.location.origin
            + "/search/Init"
            + "?q="
            + searchWord;

        var cfPivot = false;
        var tagsPivot = false;

        if (freshSearch == false) {
            url += "&sort=" + sortBy;

            if (category != undefined && category != "" && category != "Select a Category") {
                url += "&cf=" + category;
                cfPivot = true;
            }

            if (tags != undefined && tags != "" && tags != "Select a Topic" && tags != "All Topics") {
                url += "&tags=" + encodeURIComponent(tags);
                tagsPivot = true;
            }

            if (pivot != undefined && pivot != "") {

                if (cfPivot && tagsPivot) {
                    url += "&pivot=" + pivot;
                } else if (cfPivot) {
                    url += "&pivot=cf";
                } else if (tagsPivot) {
                    url += "&pivot=tags";
                }

            }
        }

        verifyThenNavigate(url);
    }

    $("input#searchBox").autocomplete({
        source: function (request, response) {

            sortBy = $("#sort").val() == undefined ? sortBy : $("#sort").val();

            $.ajax({
                url: window.location.origin + "/search/AutoComplete",

                data: {
                    q: request.term,
                    sort: sortBy
                },
                success: function (data) {
                    var itemArray = new Array();

                    var results = data.results;

                    for (i = 0; i < results.length; i++) {

                        itemArray[i] = {
                            label: results[i].document.title + " - " + results[i].document.category,
                            value: results[i].document.title,
                            data: results[i]
                        }
                    }

                    console.log(itemArray);
                    response(itemArray);
                },
                error: function (data, type) {
                    console.log(type);
                }
            });
        },
        select: function (event, ui) {

            sortBy = $("#sort").val() == undefined ? sortBy : $("#sort").val();

            var url = window.location.origin
                + "/search/Init"
                + "?q="
                + ui.item.data.document.title
                + "&sort="
                + sortBy;

            verifyThenNavigate(url);
        }
    });

    $(".search-result").mousedown(function (event) {
        logSearchResultClick(searchTerm,
            $(this).attr("data-documentId"),
            $(this).attr("data-position"),
            $(this).attr("data-title"),
            $(this).attr("data-category"));
    });

    function logSearchResultClick(searchWord, documentId, position, title, category) {

        var url = window.location.origin + "/search/TrackSearchResultActivity"
            + "?searchWord=" + searchWord
            + "&documentId=" + documentId
            + "&position=" + position
            + "&title=" + title
            + "&category=" + category;

        $.ajax({
            url: url,
            type: "POST",
            dataType: "json",
            contentType: "application/json; charset=utf-8",
            headers: {
                RequestVerificationToken:
                    $('input:hidden[name="__RequestVerificationToken"]').val()
            },
            success: function () {
            },
            error: function () {
            }
        });
    }

    $(".sponsoredAd a").mousedown(function (event) {
        logSponsoredAdClick(searchTerm,
            $(this).attr("aria-label"),
            $(this).attr("href"),
            $(this).attr("data-documentId"),
            $(this).attr("data-position"));
    });

    function logSponsoredAdClick(searchWord, vendorName, vendorLink, documentId, position) {

        var url = window.location.origin + "/search/TrackSponsoredAdActivity"
            + "?searchWord=" + searchWord
            + "&vendorName=" + vendorName
            + "&vendorLink=" + vendorLink
            + "&documentId=" + documentId
            + "&position=" + position;

        $.ajax({
            url: url,
            type: "POST",
            dataType: "json",
            contentType: "application/json; charset=utf-8",
            headers: {
                RequestVerificationToken:
                    $('input:hidden[name="__RequestVerificationToken"]').val()
            },
            success: function () {
            },
            error: function () {
            }
        });
    }
});